<template>
  <div class="layout-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="设置" name="1">
          <cx-slider class="cxSlider" label="切换方式" :value.sync="changeWayType" :options="changeWayList" />
          <div class="verticallyCenter mt12">
            <span class="fs14 mr20">默认展开第</span>
            <el-input class="cx_style width76" v-model="openIndex" placeholder="请输入"
              v-inputHandle="{ this1, type: 'openIndex', env: request_prefix, max: inputMax, min: 1 }" type="number"
              @focus="getFocus($event)">
              <template slot="suffix">
                <span class="suffix_text"></span>
              </template>
            </el-input>
            <span class="ml8">页</span>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { isExist } from "../../../utils"
export default {
  name: "cell-layout-options-config",
  props: {
    mouseType: {
      default: "default",
      type: String
    },
    options: Object
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      this1: this,
      changeWayList: [
        {
          value: "0",
          title: "点击"
        },
        {
          value: "1",
          title: "悬浮"
        }
      ],
    }
  },
  watch: {
  },
  components: {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    topPageLayout(){
      let pageLayout = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      })
      return pageLayout
    },
    topPageLayoutOptions() {
      return this.topPageLayout?.options?.layout
    },
    inputMax(){
      return this.topPageLayoutOptions?.layout?.rows[0]?.layout?.cols?.length
    },
    changeWayType: {
      get() {
        return this.topPageLayoutOptions?.options?.hasOwnProperty("changeWayType") ? this.topPageLayoutOptions?.options.changeWayType : "0"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "changeWayType", false, null, {
          container_id: this.ids.container_id, 
          rect_id: this.ids.rect_id,
          pageLayoutId: "0"
        })
      }
    },
    openIndex: {
      get() {
        return this.topPageLayoutOptions?.options?.hasOwnProperty("defaultOpenIndex") ? this.topPageLayoutOptions?.options.defaultOpenIndex + 1 : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal - 1, "defaultOpenIndex", false, null, {
          container_id: this.ids.container_id, 
          rect_id: this.ids.rect_id,
          pageLayoutId: "0"
        })
      }
    },
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    },
    handleCellSet(val, key, avoidRecord) {
      let rectId = this.ids.rect_id
      let pageLayoutId = this.ids.pageLayoutId
      if (isExist(rectId) && !isExist(pageLayoutId)) {
        this.$changeOptionsEV(
          val,
          key,
          false,
          undefined,
          {
            ...this.ids,
            pageLayoutId: "1_0"
          },
          !!avoidRecord
        )
      }
      if (
        rectId === null ||
        typeof rectId === "undefined" ||
        pageLayoutId === null ||
        typeof pageLayoutId === "undefined"
      ) {
        return
      }

      this.$changeOptionsEV(val, key, false, false, false, !!avoidRecord)
    },
  }
}
</script>

<style lang="scss">
p {
  margin-bottom: 0;
}
.cxSlider>.mr16{
  margin-right: 36px;
}
.width76 {
  width: 76px;
}
</style>
